import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import { toast } from "react-toastify";
import * as _ from 'lodash';
import { ISortBy, IBaseResponse, IDonorEvalRecord } from '@nkr/models/index';
import { IReportState, IApplicationState, AppActionCreators, BillingActionCreators, IDonorEvalResponse } from "@nkr/store/index";
import { Glyphicon, FormControl, Row, Button, Col } from 'react-bootstrap';
import DonorEvalRow from './donor-eval-row';
import { statusMap } from '../../center-admin/billing/status-map';
import { TableWrapper } from '../../center-admin/billing/styles';
import NoData from '../../center-admin/billing/no-data';
import { downloadFile } from '../../../services/download-file';
import { DonorEvalQuery } from '@nkr/enums/donor-eval-query';

interface IOwnProps {
    
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonorEvalReport: (query: DonorEvalQuery) => Promise<IDonorEvalResponse>,
    getDonorEvalResults: (query: DonorEvalQuery) => Promise<any>,
    updatePayment: (donorEvalRecord: IDonorEvalRecord) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    sortBy: ISortBy[],
    typeFilter: any[],
    dateRange: number,
    status: number,
    report: IDonorEvalRecord[],
    isPaid: boolean
}

class DonorEvalReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        sortBy: [],
        typeFilter: [1, 2, 3, 4],
        dateRange: 0,
        status: 0,
        report: [],
        isPaid : false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.getDonorEvalReport(this.state.isPaid ? DonorEvalQuery.Paid : DonorEvalQuery.ToDo)
                .then((response: IDonorEvalResponse) => {
                    this.setState({
                        report: response.data.results
                    });

                    this.props.hideLoading();
                });
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        if (!this.state.sortBy.some(s => s.property == property))
            sortBy = [];

        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc')
                sort.direction = 'desc'
            else
                if (sort.direction == 'desc')
                    sortBy = sortBy.filter(item => item.property != property);
        } else {
            sortBy.push({ property, direction: 'asc' });
        }

        this.setState({
            sortBy
        });
    }

    handlePaymentUpdate = (donorEvalRecord: IDonorEvalRecord) => {
        this.props.showLoading('Marking Paid, one moment please...').then(() => {
            this.props.updatePayment(donorEvalRecord)
                .then((response: IBaseResponse) => {

                    if (response.data.success) {
                        toast.success("Swap '" + donorEvalRecord.recipAlias + "' has been marked paid");
                    }
                    this.getData();
                    this.props.hideLoading();
                });
        });
    }

    handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            dateRange: parseInt(e.currentTarget.value)
        });
    }

    handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            status: parseInt(e.currentTarget.value)
        });
    }

    getFilteredRows = () => {
        return this.state.report;
    }

    checkNumbers = (value: string) => {
        switch (value) {
            case 'amountOwed':
            case 'swapPositions':
                return true;
            default: return false;
        }
    }

    getRows = () => {
        const sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);
        const sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);
        const filteredRows = this.getFilteredRows();

        if (sortByProperties.some(this.checkNumbers)) {
            var sortedRows = this.state.sortBy.length > 0 ? _.orderBy(filteredRows, (item) => {
                return Number(sortByProperties.map(sortBy => {
          
                    switch (sortBy) {      
                        case 'donorAlias':
                            return item.donorAlias;
                        case 'paidAmount':
                            return item.paidAmount
                    }
                    return item[sortBy];
                }));
            }, sortByDirections) : filteredRows;
        } else {
            var sortedRows = this.state.sortBy.length > 0 ? _.orderBy(filteredRows, (item) => {
                return sortByProperties.map(sortBy => {
                    switch (sortBy) {
                        case 'paidDate': return moment(item.paidDateTime).format('YYMMDD');
                        case 'donorCenterAlias': return item.donorCenterAlias;
                        case 'donorAlias': return item.donorAlias;
                        case 'recipientCenterAlias': return item.recipCenterAlias;
                        case 'recipientAlias': return item.recipAlias;
                        case 'achConfirmation': return item.achConfirmation;
                    }
                    return item[sortBy];
                });
            }, sortByDirections) : filteredRows;
        }


        return sortedRows;
    }


    handleDonorEvalResults = () => {
        this.props.getDonorEvalResults(this.state.isPaid ? DonorEvalQuery.Paid : DonorEvalQuery.ToDo).then((response: any) => {
            downloadFile(response.data, `donor-eval-results.csv`, 'text/csv');
        });
    }



    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    onPaidSearchToggle = (e) => {
        var isPaid = e.target.value === 'true';
        this.setState({ isPaid : isPaid }, () => this.getData());
    }

    render = () => {
        const rows = this.getRows();
        const missingAchInfo = true; 
        const showAlert = rows.length > 0 && missingAchInfo

        return (
            <>
                <div style={{ marginTop: 0 }}>
                    <div style={{ border: '1px solid #ddd', marginLeft: '1%', marginRight: '1%', borderRadius: 4 }}>


                        <div className='well well-sm'>
                            <div className="row">
                                <div className="col-xs-6 col-sm-3 col-lg-2" style={{paddingTop:"20px"}}>
                                    <div className="btn-group" data-toggle="buttons">
                                        <button type='button' className={"btn " + (this.state.isPaid == false ? 'btn-primary active' : 'btn-default')} value='false' onClick={this.onPaidSearchToggle.bind(this)}>To-Do</button>
                                        <button type='button' className={"btn " + (this.state.isPaid == true ? 'btn-primary active' : 'btn-default')} value='true' onClick={this.onPaidSearchToggle.bind(this)}>Paid</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        {rows.length > 0 ?
                            <TableWrapper striped>
                                <thead>
                                    <tr>
                                        <th>Rank</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('workupBillType')}> Type {this.renderHeaderSort('workupBillType')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenterAlias')}> Donor Center {this.renderHeaderSort('donorCenterAlias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorAlias')}>Donor Alias {this.renderHeaderSort('donorAlias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipCenterAlias')}>Recipient Center{this.renderHeaderSort('recipCenterAlias')}</th>                                    
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipAlias')}>Recipient Alias {this.renderHeaderSort('recipAlias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('workUpDate')}>Workup Date {this.renderHeaderSort('workUpDate')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('transplantDate')}>Tpx Date {this.renderHeaderSort('transplantDate')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('invoiceDate')}>Invoice Date {this.renderHeaderSort('invoiceDate')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('paymentDueAmount')}>Invoice Amount {this.renderHeaderSort('paymentDueAmount')}</th>
                                        <th style={{ cursor: 'pointer', width: '10px' }} onClick={() => this.handleSort('paymentDueDate')}>Pay By {this.renderHeaderSort('paymentDueDate')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenterHasAchOnFile')}>ACH {this.renderHeaderSort('donorCenterHasAchOnFile')}</th>                               
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('previousBilling')}> Dupe {this.renderHeaderSort('previousBilling')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('paidDateTime')}> Paid Date {this.renderHeaderSort('paidDateTime')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('paidAchConfirmation')}>ACH Confirmation {this.renderHeaderSort('paidAchConfirmation')}</th>                 
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((item, index) =>
                                        <DonorEvalRow
                                            rank={index + 1}
                                            data={item}
                                            query={this.state.isPaid ? DonorEvalQuery.Paid : DonorEvalQuery.ToDo}
                                            updatePayment={this.handlePaymentUpdate}
                                        />
                                    )}
                                </tbody>
                            </TableWrapper>
                            :
                            <NoData message={'No ' + (this.state.status > 0 ? statusMap[this.state.status] : '') + ' charges...'} />
                        }
                        <br />
                    </div>

                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorEvalReport: (query) => {
            return dispatch(BillingActionCreators.getDonorEvalReport(query));
        },
        getDonorEvalResults: (query) => { return dispatch(BillingActionCreators.getDonorEvalResults(query)); },
        updatePayment: (donorEvalRowRecord) => { return dispatch(BillingActionCreators.updateDonorEvalRecord(donorEvalRowRecord)); }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorEvalReport);